import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import DayPickerRaw from '~/components/common/DayPicker'

const DayPicker = ({
  disabled,
  field,
  form,
  clearable,
  error,
  helperText,
  inputProps,
  onChange,
  ...props
}) => (
  <DayPickerRaw
    {...field}
    {...props}
    disabled={disabled || !!form.values.__readOnly}
    value={field.value || ''}
    onChange={(v) => {
      form.setFieldValue(field.name, v)
      onChange?.(v)
    }}
    onClear={clearable ? () => form.setFieldValue(field.name, '') : null}
    inputProps={{
      name: field.name,
      error:
        !!error ||
        (!!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)),
      helperText:
        helperText ||
        (getIn(form.touched, field.name) && getIn(form.errors, field.name)),
      ...inputProps,
    }}
  />
)
DayPicker.defaultProps = {
  disabled: false,
  clearable: false,
  error: '',
  helperText: '',
  inputProps: {},
  onChange: () => {},
}

DayPicker.propTypes = {
  disabled: PropTypes.bool,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  clearable: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  inputProps: PropTypes.shape(),
  onChange: PropTypes.func,
}

export default DayPicker
